export default {
  SAVE_USER_DATA_TO_STORE: 'users/SAVE_USER_DATA_TO_STORE',
  ADD_USER_DATA_TO_STORE: 'users/ADD_USER_TO_STORE',
};
